const l = [
  { label: "是", value: "yes" },
  { label: "否", value: "no" }
], a = l.reverse(), e = [
  {
    label: "已發佈",
    value: "publish",
    color: "blue"
  },
  {
    label: "送交審閱",
    value: "pending",
    color: "volcano"
  },
  {
    label: "草稿",
    value: "draft",
    color: "orange"
  },
  {
    label: "私密",
    value: "private",
    color: "purple"
  },
  {
    label: "回收桶",
    value: "trash",
    color: "red"
  }
], o = e, r = [
  {
    label: "網站管理員",
    value: "administrator",
    color: "red"
  },
  {
    label: "商店經理",
    value: "shop_manager",
    color: "orange"
  },
  {
    label: "編輯",
    value: "editor",
    color: "pink"
  },
  {
    label: "作者",
    value: "author",
    color: "green"
  },
  {
    label: "翻譯",
    value: "translator",
    color: "cyan"
  },
  {
    label: "投稿者",
    value: "contributor",
    color: "purple"
  },
  {
    label: "顧客",
    value: "customer",
    color: "blue"
  },
  {
    label: "訂閱者",
    value: "subscriber",
    color: "gray"
  }
];
export {
  l as BOOLEAN_OPTIONS,
  a as BOOLEAN_OPTIONS_REVERSE,
  e as POST_STATUS,
  o as PRODUCT_STATUS,
  r as USER_ROLES
};
